import { render, staticRenderFns } from "./invoiceTemp_CBS.vue?vue&type=template&id=38e2ef4a&scoped=true&"
import script from "./invoiceTemp_CBS.vue?vue&type=script&lang=js&"
export * from "./invoiceTemp_CBS.vue?vue&type=script&lang=js&"
import style0 from "./invoiceTemp_CBS.vue?vue&type=style&index=0&id=38e2ef4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e2ef4a",
  null
  
)

export default component.exports